import Vue from 'vue';
import { STORE } from '@/core/store/core.store';
import { WidgetTeacherCourse } from '@/homework/models/widget-teacher-course.model';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { Status } from '@/models/status.model';
import EdHomeworkTeacherSectionList from '../ed-homework-teacher-section-list/ed-homework-teacher-section-list.vue';
import { _HOMEWORKS_STORE } from '@/homework/values/homeworks.values';
import { TEACHER_PORTAL_KEYS } from '@/content/pages/teacher-portal/values/teacher-portal.values';
import { LocalStorageService } from '@/services/local-storage.service';

@Component({
  name: 'ed-homework-widget-course',
  components: {
    EdHomeworkTeacherSectionList
  }
})
export default class EdHomeworkWidgetCourseSection extends Vue {

  @Prop() readonly widgetCourse : WidgetTeacherCourse;
  
  public sectionsStatus: Status = new Status();

  get title() {
    return this.widgetCourse.title;
  }

  get opened() {
    let courseOpened: WidgetTeacherCourse = this.$store.state.HomeworksStore.teacherWidgetHomeworksSection.courseOpened;
    return courseOpened ? (this.widgetCourse.classId == courseOpened.classId && this.widgetCourse.id == courseOpened.id) : false;
  }

  get sections() {
    return this.widgetCourse.sections.content;
  }

  get hasMoreSections() {
    return this.widgetCourse.sections.more;
  }

  get tasksListContainer() {
    if(this.opened) {
      this.scrollToCourse();
      return {
        height:'auto',
        maxHeight: this.widgetCourse.maxHeight <= 0 ? '350px' : `${this.widgetCourse.maxHeight}px`
      };
    } else {
      return { maxHeight: 0 };
    }
  }

  scrollToCourse() {
    setTimeout(() => {
      let element: any = this.$el
      let maxHeightSectionsList = this.widgetCourse.maxHeight;
      let scrollTopPosition = element.offsetTop;
      let heightInTheContainer = (maxHeightSectionsList + scrollTopPosition);
      if(heightInTheContainer > this.$parent.$el.clientHeight) {
        this.$parent.$el.scrollTo({top: scrollTopPosition})
      }
    }, 110);
  }
  
  toggleCourse() {
    this.$store.commit(_HOMEWORKS_STORE.MUTATIONS.OPEN_WIDGET_TEACHER_COURSE_SECTION, this.widgetCourse);
  }

  async getMoreSections() {
    try {
      this.sectionsStatus.setLoading();
      await this.$store.dispatch(_HOMEWORKS_STORE.ACTIONS.GET_TEACHER_SECTIONS_FROM_COURSE_HOMEWORK, this.widgetCourse);
      this.sectionsStatus.setLoad();
      this.setContainerHeight();
    } catch(err) {
      this.sectionsStatus.setError();
    }
  }

  setContainerHeight() {
    let tasksContainer: any = this.$refs.tasksContainer;
    let maxHeightContainer = (this.$parent.$el.clientHeight - 70);
    let maxHeightSectionsList = (tasksContainer.scrollHeight + 95);
    if (this.$parent.$el.clientHeight == 0) this.widgetCourse.maxHeight = 350;
    else this.widgetCourse.maxHeight = maxHeightSectionsList > maxHeightContainer ? maxHeightContainer : maxHeightSectionsList;
    this.$store.commit(_HOMEWORKS_STORE.MUTATIONS.UPDATE_WIDGET_TEACHER_COURSE_SECTION, this.widgetCourse);
  }

  getCourseLocalStorage() {
    let courseId = LocalStorageService.getItem(TEACHER_PORTAL_KEYS.TASKS_COURSE_ID);
    if(courseId == this.widgetCourse.id) {
      if(!this.opened) this.toggleCourse();
      LocalStorageService.removeItem(TEACHER_PORTAL_KEYS.TASKS_COURSE_ID);
    }
  }

  created() {
    this.getCourseLocalStorage();
  }

  mounted() {
    this.$nextTick(() => {
      setTimeout(this.setContainerHeight, 500);
    });
  }

}
